import { type IntegrationStatusConstructor } from '@webapp/platform/integrations'
import { type IntegrationStatusApiModel } from '../api-models/IntegrationStatusApiModel'

export const mapIntegrationStatus = (
  integrationStatus: IntegrationStatusApiModel
): IntegrationStatusConstructor => ({
  integrationConnections: {
    netsuiteV2: integrationStatus.integration_connections.netsuite_v2,
    punchout: integrationStatus.integration_connections.punchout,
    quickbooks: integrationStatus.integration_connections.quickbooks,
    quickbooksOnline:
      integrationStatus.integration_connections['quickbooks-online'],
    slack: integrationStatus.integration_connections.slack,
  },
  slackIntegration: {
    slackRedirectUrl: integrationStatus.slack_integration.slack_redirect_url,
    slackState: integrationStatus.slack_integration.slack_state,
    slackClientId: integrationStatus.slack_integration.slack_client_id,
  },
})
